var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { Decimal } from '@sovryn/utils';
import { getLiquityBaseParams } from '../utils';
export const useLiquityBaseParams = () => {
    const [liquityBaseParams, setLiquityBaseParams] = useState({
        minBorrowingFeeRate: Decimal.ZERO,
        maxBorrowingFeeRate: Decimal.ZERO,
    });
    useEffect(() => {
        const getBorrowingFee = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const { minBorrowingFeeRate, maxBorrowingFeeRate } = yield getLiquityBaseParams();
                setLiquityBaseParams({
                    minBorrowingFeeRate,
                    maxBorrowingFeeRate,
                });
            }
            catch (error) {
                console.error(error);
            }
        });
        getBorrowingFee();
    }, []);
    return liquityBaseParams;
};
